import { ConfigProvider, Input, Table } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_ENDPOINTS } from '../../assets/api/endpoints';
import './Maintenance.scss';
import Header from '../../components/Header/Header';
import axios from 'axios';
import { SearchOutlined } from '@ant-design/icons';
import { getMaintenanceColumn } from '../../helpers/MaintenanceColumn';
import { themeConfig } from '../WalletTransactions/config';
import { StyledPagination } from '../../components/table.style';
import { useConfigurationContext } from '../../store/configurationContext';
import dayjs from 'dayjs';
import { DATE_TIME_FORMAT } from '../../constant/dateFormat';

const Maintenance = () => {
	const { t } = useTranslation();
	const [annoncementLoading, setAnnoncementLoading] = useState(false);
	const [annoncement, setAnnoncement] = useState([]);
	const [searchTerm, setSearchTerm] = useState('');
	const [page, setPage] = useState(0);
	const [totalElements, setTotalElements] = useState(0);
	const [pageSize, setPageSize] = useState(10);
	const [filterdData, setFilteredData] = useState([]);
	const { configurationState } = useConfigurationContext();
	const themeColor = configurationState.find((item) => item.configKey === 'theme_color')?.value || '';
	const secondary_color = configurationState.find((item) => item.configKey === 'secondary_color')?.value || '';

	const reloadDataCallback = () => {
		setAnnoncementLoading(true);
		axios
			.get(`${API_ENDPOINTS.annoncement}`)
			.then((result) => {
				setAnnoncementLoading(false);
				setAnnoncement(result.data);
				setFilteredData(result.data);
				setTotalElements(result.data.length);
			})
			.catch((err) => setAnnoncementLoading(false));
	};
	useEffect(() => {
		reloadDataCallback();
	}, []);

	useEffect(() => {
		const data = annoncement.filter((item: any) => {
			const formattedStart = dayjs(item.startDate).format(DATE_TIME_FORMAT).toLowerCase();
			const formattedEnd = dayjs(item.endDate).format(DATE_TIME_FORMAT).toLowerCase();
			return (
				formattedStart.includes(searchTerm.toLocaleLowerCase()) || formattedEnd.includes(searchTerm.toLocaleLowerCase())
			);
		});
		setFilteredData(data);
	}, [searchTerm]);
	return (
		<div className='countries-and-paym-container'>
			<Header title={t<string>('maintenance')} description={t<string>('maintenanceSubtitle')} />
			<div className='min-h-[84vh] mx-auto px-5 py-5 bg-white'>
				<div className='flex justify-end items-center my-2'>
					<Input
						className='border-none h-10 bg-[#F5F5F5] search-input w-[200px] xss:my-4 lg:my-0'
						placeholder={t<string>('searchMaintatance')}
						value={searchTerm}
						onChange={(e) => {
							setSearchTerm(e.target.value);
						}}
						size='large'
						prefix={<SearchOutlined className='mr-2' />}
					/>
				</div>
				<ConfigProvider theme={themeConfig}>
					<StyledPagination bgColor={themeColor} color={secondary_color}>
						<Table
							columns={getMaintenanceColumn(t, reloadDataCallback)}
							dataSource={filterdData}
							pagination={{
								pageSize,
								total: totalElements,
								onChange: (pageIndex) => setPage(pageIndex - 1),
								current: page + 1,
							}}
							loading={annoncementLoading}
							tableLayout='auto'
						/>
					</StyledPagination>
				</ConfigProvider>
			</div>
		</div>
	);
};

export default Maintenance;
